import {SET_MODALVISIBLE} from "../bulkfxupdate/bulkFxUpdateType";
import {
    EXPORT_ORDER_DONE,
    LOADING,
    SET_DO_EXPORT,
    SET_DO_EXPORT_CLICK,
    SET_DO_EXPORT_DONE,
    SET_DO_EXPORT_ERROR,
    SET_LOADING
} from "./orderExportType";

const initState ={
    condition:{

    },
    res:{},
    error:'',
    loading: false,
    data:{},
    loadingBtn:false
}

const orderExportReducer = (state = initState, action) =>{
    switch (action.type) {
        case SET_DO_EXPORT_CLICK: {
            return {
                ...state,
                loading:true
            }
        }

        case SET_DO_EXPORT_ERROR: {
            return {
                ...state,
                loading: false,
                loadingBtn:false
            }
        }

        case SET_DO_EXPORT_DONE: {
            return {
                ...state,
                loading: false,
                loadingBtn:false
            }
        }

        case LOADING: {
            return {
                ...state,
                loading: action.loading
            }
        }

        case EXPORT_ORDER_DONE: {
            return {
                ...state,
                data:action.data,
                loading: action.loading
            }
        }

        default:
            return state;
    }
}

export default orderExportReducer;